import React from 'react';

import { Select } from '@/design-system/atoms/Forms/Select';
import { Text } from '@/design-system/atoms/Text';

import styles from '../../BioReviews.module.scss';

const Toolbar = ({ numberOfReviews, selectedKey, onSelectionChange, dropdownRef, ...props }) => {
    const options = [
        { id: 'recency', text: 'Recent' },
        { id: 'rating', text: 'Rating' },
    ];
    return (
        <div className={styles[`bio-reviews__toolbar`]}>
            <Text
                tag="div"
                variant={Text.VARIANT.T2}
                content={`${numberOfReviews} reviews`}
                className={styles[`bio-reviews__summary`]}
            />
            <div className={styles[`bio-reviews__sorting`]}>
                <Select
                    ref={dropdownRef}
                    aria-label={'Sort by'}
                    items={options}
                    selectedKey={selectedKey}
                    popoverClassName={styles['bio-reviews__sorting-popover']}
                    onSelectionChange={onSelectionChange}
                    analytics={{ selector: 'sort' }}
                />
            </div>
        </div>
    );
};

export default Toolbar;
